import { useDialog, useMobileMenu, usePlatformStore } from "@platform/store";
import { useFetchUserCircles } from "@core/features/circle";
import { ProgramAddCalendarEventsDialog } from "./ProgramAddCalendarEventsDialog";
import { useUserTimezoneOption } from "@platform/hooks/useUserTimezoneOption";
import { programEventBus } from "@platform/events/program.events";
import { useProgram } from "@platform/hooks/useProgram";
import { useUserMeetings } from "@platform/hooks/useUserMeetings";

export function ProgramAddCalendarEventsContainer() {
  const { program } = useProgram();
  const { activeDialog, closeDialog } = useDialog();
  const user = usePlatformStore((s) => s.user);

  const userTimezoneOption = useUserTimezoneOption();

  const { close: closeMobileMenu } = useMobileMenu();

  const isOpen = activeDialog === "addCalendarEvents";

  const { data: circlesData } = useFetchUserCircles({ user });
  const circle = circlesData?.circles?.[0];

  const { meetings } = useUserMeetings();

  const handleDone = async () => {
    // close the dialog
    closeDialog();

    closeMobileMenu();
  };

  const handleAddCalendarEvent = (
    meetingId: number | string | "all",
    calendarType: "google" | "ical"
  ) => {
    // When used with meetings, IDs are numbers. Cast for event bus compatibility.
    const numericMeetingId = meetingId === "all" ? "all" : Number(meetingId);
    programEventBus.emitEvent("program:addToCalendarModal:addCalendarEvent", {
      programId: program?.id ?? 0,
      circleId: circle?.id ?? 0,
      meetingId: numericMeetingId,
      calendarType,
    });
  };

  return (
    <ProgramAddCalendarEventsDialog
      meetings={meetings}
      userTimezone={userTimezoneOption ?? undefined}
      onClose={handleDone}
      onAddCalendarEvent={handleAddCalendarEvent}
      isOpen={isOpen}
    />
  );
}

export default ProgramAddCalendarEventsContainer;

